<app-modal id="app-grouping-tag">
	<div modal-body class="grouping-tag__body" (keyup.enter)="onSave()">
		<div class="grouping-tag__field grouping-tag__field--label">
			<label [attr.for]="cmpId + '-label-input'" i18n="@@groupingTag.label">
				label
			</label>
			<input
				type="text"
				class="grouping-tag__input"
				[class.grouping-tag__input--error]="labelRequiredError"
				[id]="cmpId + '-label-input'"
				name="label"
				required
				[maxlength]="LABEL_MAX_LEN"
				placeholder="tagLabel"
				i18n-placeholder="@@groupingTag.label.placeholder"
				[ngModel]="tagLabel"
				(ngModelChange)="setNewLabel($event)" />
			<span class="grouping-tag__counter">
				{{ tagLabel.length }}/{{ LABEL_MAX_LEN }}
			</span>
		</div>

		<div
			class="grouping-tag__field grouping-tag__field--color">
			<label [attr.for]="cmpId + '-color-input'" i18n="@@groupingTag.color">
				color
			</label>
			<div class="grouping-tag__color-row">
				<ngx-colors
					ngx-colors-trigger
					class="grouping-tag__color-picker"
					name="colorPicker"
					attachTo="app-grouping-tag"
					[format]="allowedFormats"
					[hideTextInput]="hideTextInput"
					[hideColorPicker]="hideColorPicker"
					[acceptLabel]="acceptLabel"
					[cancelLabel]="cancelLabel"
					[ngModel]="tagColor"
					(ngModelChange)="setNewColor($event)"></ngx-colors>
				<input
					type="text"
					class="grouping-tag__input"
					[class.grouping-tag__input--error]="colorRequiredError || colorPatternError"
					[id]="cmpId + '-color-input'"
					name="color"
					required
					[pattern]="colorPattern"
					placeholder="tagColor"
					i18n-placeholder="@@groupingTag.color.placeholder"
					[ngModel]="tagColor"
					(ngModelChange)="setNewColor($event)" />
			</div>
		</div>

		<div class="grouping-tag__errors">
			<p
				*ngIf="labelRequiredError"
				class="grouping-tag__error"
				i18n="@@groupingTag.errors.labelRequired">
				Label is required
			</p>
			<p
				*ngIf="colorRequiredError"
				class="grouping-tag__error"
				i18n="@@groupingTag.errors.colorRequired">
				Color is required
			</p>
			<p
				*ngIf="colorPatternError"
				class="grouping-tag__error"
				i18n="@@groupingTag.errors.colorInvalid">
				Enter a valid hex color, e.g. #1A2B3C
			</p>
		</div>
	</div>

	<div modal-footer class="grouping-tag__footer">
		<button
			type="button"
			[attr.id]="cmpId + '-cancel-btn'"
			class="grouping-tag__btn grouping-tag__btn--ghost"
			(click)="onCancel()"
			i18n="@@general.edit.cancel">
			cancel
		</button>
		<button
			type="button"
			[attr.id]="cmpId + '-save-btn'"
			class="grouping-tag__btn grouping-tag__btn--primary"
			[disabled]="!isValid()"
			(click)="onSave()"
			i18n="@@general.action.save">
			save
		</button>
	</div>
</app-modal>
